export enum UserRole {
  Admin = 'Admin',
  Employee = 'Employee',
  Boss = 'Boss',
}
